import { render, staticRenderFns } from "./VoiceBlastTemplateEntity.vue?vue&type=template&id=3f9cbdac"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports